import apiMiddlewareActionTypes from "App/apiMiddleware/redux/actionTypes";
import listenerMiddleware from "App/listenerMiddleware";
import connectionsActionTypes from "Areas/Settings/connections/redux/actionTypes";
import { LAYOUT_ALGORITHM } from "Common/dictionaries/layoutAlgorithm";
import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import forEach from "lodash/forEach";
import keyBy from "lodash/keyBy";
import { NAMESPACE } from "../constants";
import generateNodeColor from "../utils/generateNodeColor";
import actionCreators from "./actionCreators";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        sourceData: undefined,
        draftData: undefined,
        outdated: false,
        usedByUI: false,
        detailedPanelOpen: false,
        layoutAlgorithm: LAYOUT_ALGORITHM.ORGANIC,
        hasChanges: false,
        showNames: false,
        filterText: "",
        panelWidth: undefined
    }
};
const setOntologicalModel = (state, payload) => {
    let result = state;
    const documentObjectsMap = {};
    const groupNameToColorMap = {};
    forEach(payload.DocumentObjects, d => {
        if (d.Color || !d.GroupName) {
            documentObjectsMap[d.Id] = d;
            return;
        }
        if (!groupNameToColorMap[d.GroupName])
            groupNameToColorMap[d.GroupName] = generateNodeColor(d);
        documentObjectsMap[d.Id] = { ...d, Color: groupNameToColorMap[d.GroupName] };
    });
    const transformsMap = keyBy(payload.Transforms, "Id");
    result = set(result, `[${NAMESPACE}].sourceData`, {
        DocumentObjects: documentObjectsMap,
        Transforms: transformsMap
    });
    result = set(result, `[${NAMESPACE}].draftData`, {
        DocumentObjects: documentObjectsMap,
        Transforms: transformsMap
    });
    result = set(result, `[${NAMESPACE}].hasChanges`, false);
    result = set(result, `[${NAMESPACE}].outdated`, false);
    result = set(result, `[${NAMESPACE}].usedByUI`, true);
    return result;
};
export default createReducer(initialState, {
    [actionTypes.GET_ONTOLOGICAL_MODEL_COMPLETED]: (state, { payload }) => setOntologicalModel(state, payload),
    [actionTypes.SAVE_ONTOLOGICAL_MODEL_COMPLETED]: (state) => set(state, `[${NAMESPACE}].hasChanges`, false),
    [actionTypes.SET_OUTDATED]: (state) => set(state, `[${NAMESPACE}].outdated`, true),
    [actionTypes.SET_USED_BY_UI]: (state) => set(state, `[${NAMESPACE}].usedByUI`, true),
    [actionTypes.SET_ONTOLOGICAL_MODEL]: (state, { data, updateSourceData }) => {
        if (!state[NAMESPACE].draftData)
            return state;
        let result = state;
        if (data.documentObjects !== undefined) {
            const documentObjectsMap = data.onlyDiffSources
                ? { ...state[NAMESPACE].draftData.DocumentObjects, ...keyBy(data.documentObjects, "Id") }
                : keyBy(data.documentObjects, "Id");
            result = set(result, `[${NAMESPACE}].draftData.DocumentObjects`, documentObjectsMap);
            if (updateSourceData) {
                result = set(result, `[${NAMESPACE}].sourceData.DocumentObjects`, documentObjectsMap);
            }
        }
        if (data.transforms !== undefined) {
            const transformsMap = data.onlyDiffSources
                ? { ...state[NAMESPACE].draftData.Transforms, ...keyBy(data.transforms, "Id") }
                : keyBy(data.transforms, "Id");
            result = set(result, `[${NAMESPACE}].draftData.Transforms`, transformsMap);
            if (updateSourceData) {
                result = set(result, `[${NAMESPACE}].sourceData.Transforms`, transformsMap);
            }
        }
        if (!updateSourceData) {
            result = set(result, `[${NAMESPACE}].hasChanges`, true);
        }
        return result;
    },
    [actionTypes.SET_DETAILED_PANEL_OPEN]: (state, { detailedPanelOpen }) => set(state, `[${NAMESPACE}].detailedPanelOpen`, detailedPanelOpen),
    [actionTypes.SET_HAS_CHANGES]: (state, { hasChanges }) => set(state, `[${NAMESPACE}].hasChanges`, hasChanges),
    [actionTypes.SET_LAYOUT_ALGORITHM]: (state, { layoutAlgorithm }) => set(state, `[${NAMESPACE}].layoutAlgorithm`, layoutAlgorithm),
    [actionTypes.SET_SHOW_NAMES]: (state, { showNames }) => set(state, `[${NAMESPACE}].showNames`, showNames),
    [actionTypes.SET_FILTER_TEXT]: (state, { filterText }) => set(state, `[${NAMESPACE}].filterText`, filterText),
    [actionTypes.SET_PANEL_WIDTH]: (state, { width }) => set(state, "panelWidth", width)
});
const loadOntologicalModel = (_, dispatch) => {
    dispatch(actionCreators.getOntologicalModel(false, true));
};
listenerMiddleware.addListener({
    [apiMiddlewareActionTypes.REQUEST_STARTED]: ({ scope }, dispatch) => {
        if (scope === connectionsActionTypes.RELOAD_ONTOLOGY)
            dispatch(actionCreators.setOutdated());
    },
    [connectionsActionTypes.RELOAD_ONTOLOGY_COMPLETED]: loadOntologicalModel,
    [connectionsActionTypes.RELOAD_ONTOLOGY_REJECTED]: loadOntologicalModel
});
